module.exports = __webpack_public_path__ + "img/402.85bc1dc7.png";